<template>
  <div class="row spinner-parent">
    <div class="col-12">
      <div class="col-12">
        <div class="card">
          <div class="card-header">
            <h1>Document Files</h1>
          </div>
        </div>
      </div>

      <div class="col-12">
        <div class="card">
          <div class="card-header">
            <strong>Manage Documents</strong>
            <router-link
              class="btn btn-primary btn-sm pull-right"
              style="margin-left: 15px;"
              :to="{ name: 'DocumentFilesAddDocs', params: { id: $route.params.id }}"
            >
              Add new Documents
            </router-link>
            <router-link
              class="btn btn-primary btn-sm pull-right"
              :to="{ name: 'DocumentFilesEdit', params: { id: $route.params.id }}"
            >
              Back to General
            </router-link>
          </div>

          <div class="card-block">
            <input
              v-model="searchQuery"
              type="text"
              class="form-control"
              placeholder="Search by Documents title"
            >
          </div>
          <div class="card-block spinner-parent">
            <spinner ref="spinner" size="md" text="Loading ..." />

            <div class="table-responsive">
              <table class="entities table table-bordered table-striped table-sm">
                <thead>
                  <tr>
                    <th>ID</th>
                    <th>Title</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody v-if="!total">
                  <tr>
                    <td colspan="4" class="text-center">
                      There are no documents yet. Go to 'Add new Documents' to add new ones.
                    </td>
                  </tr>
                </tbody>
                <tbody v-else>
                  <tr v-for="item in docs" :key="item.id" :data-id="item.id">
                    <td class="table-list__cell--narrow">{{ item.id }}</td>
                    <td>{{ item.title }}</td>
                    <td class="table-list__cell--narrow">
                      <button
                        class="btn btn-danger btn-sm"
                        @click="deleteMediaDoc(item)"
                      >
                        Delete
                        <span class="btn-loader" style="display: none;" />
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <nav>
              <pager
                :total="total"
                :offset="offset"
                :size="perPage"
                @page-changed="changePage"
              />
            </nav>
          </div>
        </div>
      </div>
    </div>
  </div><!--/.row-->
</template>

<script>
import _ from 'lodash';
import Pager from '@/global/components/Pager';

export default {
  name: 'DocumentFilesManageDocs',

  components: {
    pager: Pager,
  },

  data() {
    return {
      searchQuery: '',
      searchProcessId: null,
      total: 0,
      offset: 0,
      perPage: null,
      docs: [],
      saveErrorMessage: 'Error in data saving',
    };
  },

  watch: {
    searchQuery: _.debounce(function () {
      this.offset = 0;
      this.getDocs();
    }, 400),
    offset() {
      this.getDocs();
    },
  },

  mounted() {
    this.getDocs();
  },

  methods: {
    getDocs() {
      if (this.$refs.spinner) { this.$refs.spinner.show(); }
      const searchString = encodeURI(this.searchQuery);
      const page = this.perPage ? (this.offset / this.perPage + 1) : 1;
      const searchProcessId = Math.random();
      this.searchProcessId = searchProcessId;
      this.$apiHttp.get(`${this.$config.app_api.prefix}media/document-files/${this.$route.params.id}/media-docs`, {
        params: {
          search_string: searchString,
          page,
        },
      }).then((response) => {
        if (this.searchProcessId === searchProcessId) {
          if (this.$refs.spinner) { this.$refs.spinner.hide(); }
          this.total = response.data.meta.pagination.total;
          this.perPage = response.data.meta.pagination.per_page;

          const docsArr = _.cloneDeep(response.data);
          delete docsArr.meta;
          this.docs = docsArr;
        }
      }).catch((error) => {
        if (this.$refs.spinner) { this.$refs.spinner.hide(); }
        console.error(error);
      });
    },
    deleteMediaDoc(doc) {
      if (window.confirm(`Do you really want to detach document ${doc.title} with id = ${doc.id}?`)) {
        const postFormData = new FormData();
        const $btnDeleteLoader = $(`table.entities tr[data-id="${doc.id}"] .btn-danger .btn-loader`);
        $btnDeleteLoader.show();
        postFormData.append('ids[]', doc.id);
        this.$apiHttp.post(
          `${this.$config.app_api.prefix}media/document-files/${this.$route.params.id}/detach/media-docs`,
          postFormData,
        ).then(() => {
          console.log(`Document ${doc.title} with ID = ${doc.id} has detached`);
          $btnDeleteLoader.hide();
          this.getDocs();
        }).catch((error) => {
          console.error('Error in detach document request', error);
          $btnDeleteLoader.hide();
        });
      }
    },
    changePage(offset) {
      this.offset = offset;
    },
  },
};
</script>



// WEBPACK FOOTER //
// ManageDocs.vue?60c5b4a8